<template>
  <section>
    <div class="flex mb-4 image-container" v-bind:style="{ backgroundImage: 'url(' + baseUrlSrc(currentThumbnailImage) + ')' }">
      <div
        class="w-full flex rounded-lg lg:max-w-7xl mb-4"
        style="height: 556px; background: black"
        v-show="isMeetingStarted"
      >
        <div class="flex-1 relative" style="width: 844px">
          <div id="meetingSDKElement"></div>
        </div>
        <!-- style="width: 308px" -->
        <div class="flex-1">
          <div id="meetingSDKChatElement"></div>
        </div>
      </div>

      <div class="relative flex-1">
        <div class="flex items-center justify-center h-full"
          v-show="!isMeetingStarted"
        >
          <!-- Thumbnail image -->
            <span class="sr-only">Watch our video to learn more</span>
            <!-- <img
              class="focus:outline-none rounded-lg"
              :src="baseUrlSrc(details && details.thumbnail_url)"
              alt=""
              @error="defaultImage"
            /> -->
            <div
              class="absolute inset-0 w-full h-full flex items-center justify-center"
              aria-hidden="true"
              v-if="details && details.status == STATUS_STARTED"
            >
              <svg
                class="h-16 w-16 text-white"
                fill="currentColor"
                viewBox="0 0 84 84"
              >
                <circle
                  opacity="0.9"
                  cx="42"
                  cy="42"
                  r="42"
                  fill=""
                  style="color: #89bf4d"
                />
                <path
                  d="M55.5039 40.3359L37.1094 28.0729C35.7803 27.1869 34 28.1396 34 29.737V54.263C34 55.8604 35.7803 56.8131 37.1094 55.9271L55.5038 43.6641C56.6913 42.8725 56.6913 41.1275 55.5039 40.3359Z"
                />
              </svg>
            </div>
          

          <!-- Students are watching -->
          <!-- <div
            class="absolute bottom-0 p-6 rounded-lg space-x-2 md:m-6 md:mb-4 my-24 bg-white w-full max-w-md"
            style="opacity: 0.9"
            v-if="details && details.upcoming_live"
          >
            <div
              class="flex items-center justify-between"
              v-if="details && details.status == STATUS_STARTED"
            >
              <div class="flex items-center" v-if="total_student">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-5 w-5 text-green-light"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                  <path
                    fill-rule="evenodd"
                    d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <p class="text-sm">
                  <span class="text-green-light">{{ total_student }}</span>
                  students are watching this video
                </p>
              </div>
              <button
                type="button"
                class="h-8 px-4 m-2 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                @click="getSignature"
                v-if="$route.name == 'UserSessionLive'"
              >
                Start Class
              </button>
              <router-link
                class="h-8 py-1 px-4 m-2 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
                :to="{
                  name: 'UserSessionLive',
                  params: { id: zoom_meeting && zoom_meeting.batch_id },
                }"
                v-else-if="zoom_meeting && zoom_meeting.batch_id"
              >
                Join Class
              </router-link>
            </div>

            Live in
            <div class="flex items-center justify-between opacity-100" v-else>
              <div class="flex items-center space-x-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-10 w-10 text-gray-light"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
                  />
                </svg>

                <div class="leading-none">
                  <p>Live <span id="countdown"></span></p>
                  <span class="text-xs text-gray-light">
                    {{
                      details &&
                      details.upcoming_live &&
                      handleMonthDateTime(details.upcoming_live)
                    }}
                    {{
                      details &&
                      details.upcoming_live &&
                      handleHour12(details.upcoming_live)
                    }}
                  </span>
                </div>
              </div>
              <button
                type="button"
                class="h-8 px-4 m-2 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-md focus:shadow-outline hover:bg-green-light"
              >
                <div class="flex items-center space-x-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg>
                  <span>Set Reminder</span>
                </div>
              </button>
            </div>
          </div> -->
          <div
            class="absolute bottom-0 p-6 rounded-lg space-x-2 md:m-2 my-24 bg-white w-full max-w-sm"
            style="opacity: 0.81"
            v-if="details && details.status == STATUS_COMPLETED"
          >
            <!-- Session completed -->
            <div class="flex items-center justify-between opacity-100">
              <div class="flex items-center space-x-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-gray-light"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5.636 18.364a9 9 0 010-12.728m12.728 0a9 9 0 010 12.728m-9.9-2.829a5 5 0 010-7.07m7.072 0a5 5 0 010 7.07M13 12a1 1 0 11-2 0 1 1 0 012 0z"
                  />
                </svg>
                <div class="leading-none">
                  <p>Class Completed</p>
                  <span class="text-xs text-gray-light">
                    {{ handleMonthDateTime(details && details.upcoming_live) }}
                    {{ handleHour12(details && details.upcoming_live) }}
                  </span>
                </div>
              </div>
              <button
                type="button"
                class="h-8 px-3 m-0 text-sm text-indigo-100 transition-colors duration-150 bg-green-light rounded-md focus:shadow-outline hover:bg-green-light"
                @click.prevent="handleGiveReview"
              >
                Give Review
              </button>
            </div>
          </div>

          
        </div>

        <div
          class="rounded-md right-0 mx-8 bottom-0 absolute py-3 px-4 mb-4"
          style="width: 272px; height: 410px; background: #3f3e3e"
          v-if="$route.name == 'UserSessionLive'"
        >
          <div
            class="relative py-2 pl-0 pr-0 leading-normal text-white rounded-lg"
          >
            <p>Send a Tip</p>
            <span class="absolute inset-y-0 right-0 flex items-center mr-0">
              <svg
                class="w-4 h-4 fill-current"
                role="button"
                viewBox="0 0 20 20"
              >
                <path
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </span>
          </div>

          <div class="flex py-2 rounded-t-lg bg-green-light">
            <img
              class="h-10 w-10 rounded-full mx-2"
              src="https://images.unsplash.com/photo-1519345182560-3f2917c472ef?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              alt=""
            />
            <div class="ml-3">
              <p class="text-sm font-medium text-white">John Smith</p>
              <p class="text-sm text-white">$2.00</p>
            </div>
          </div>

          <textarea
            class="w-full h-28 px-3 py-2 text-sm text-white placeholder-white border rounded-b-lg focus:shadow-outline"
            style="background: #2f2e2e"
            placeholder="Say something..."
          ></textarea>

          <div
            class="flex justify-center items-center my-2 py-2 rounded-lg"
            style="background: #2f2e2e"
          >
            <button class="mx-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-6 h-6 text-green-light"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm3 10.5a.75.75 0 000-1.5H9a.75.75 0 000 1.5h6z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
            <button
              class="inline-flex items-center justify-center w-10 h-10 mx-4 text-indigo-100 transition-colors duration-150 rounded-lg focus:shadow-outline"
            >
              <span class="text-2xl font-bold">$2.00</span>
            </button>
            <button class="mx-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="w-6 h-6 text-green-light"
              >
                <path
                  fill-rule="evenodd"
                  d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zM12.75 9a.75.75 0 00-1.5 0v2.25H9a.75.75 0 000 1.5h2.25V15a.75.75 0 001.5 0v-2.25H15a.75.75 0 000-1.5h-2.25V9z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>
          </div>

          <div class="grid grid-cols-5 gap-5 py-2">
            <button
              class="inline-flex items-center justify-center w-8 h-8 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              style="background: #2f2e2e"
            >
              <span class="text-xs font-semibold">$2</span>
            </button>
            <button
              class="inline-flex items-center justify-center w-8 h-8 mr-0 text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
            >
              <span class="text-xs font-semibold">$5</span>
            </button>
            <button
              class="inline-flex items-center justify-center w-8 h-8 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              style="background: #2f2e2e"
            >
              <span class="text-xs font-semibold">$10</span>
            </button>
            <button
              class="inline-flex items-center justify-center w-8 h-8 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              style="background: #2f2e2e"
            >
              <span class="text-xs font-semibold">$20</span>
            </button>
            <button
              class="inline-flex items-center justify-center w-8 h-8 mr-0 text-indigo-100 transition-colors duration-150 bg-indigo-700 rounded-lg focus:shadow-outline hover:bg-indigo-800"
              style="background: #2f2e2e"
            >
              <span class="text-xs font-semibold">$50</span>
            </button>
          </div>

          <div class="py-2">
            <button
              class="w-full h-10 px-6 text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
            >
              Send Tip
            </button>
          </div>
        </div>
        <div
          class="rounded-md right-0 mx-8 bottom-0 absolute py-3 px-4 mb-4"
          style="width: 272px; height: 410px; background: #3f3e3e"
          v-if="false"
        >
          <div
            class="relative py-2 pl-0 pr-0 leading-normal text-white rounded-lg"
          >
            <p>Payment</p>
            <span class="absolute inset-y-0 right-0 flex items-center mr-0">
              <svg
                class="w-4 h-4 fill-current"
                role="button"
                viewBox="0 0 20 20"
              >
                <path
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                  fill-rule="evenodd"
                ></path>
              </svg>
            </span>
          </div>

          <!-- Display a payment form -->
          <!-- <form id="payment-form" @submit="handleSubmit">
            <div id="payment-element">
              Stripe.js injects the Payment Element
            </div>
            <button id="submit">
              <div class="spinner hidden" id="spinner"></div>
              <span id="button-text">Pay now</span>
            </button>
            <div id="payment-message" class="hidden"></div>
          </form> -->

          <!-- <div class="py-2">
            <button
              class="w-full h-10 px-6 text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light"
            >
              Pay
            </button>
          </div> -->
        </div>
        <!-- Supporting images -->
        <div
            class="md:absolute top-0 left-0 flex md:flex-col items-center py-1 rounded md:m-6 md:space-y-3 overflow-y-auto"
            v-if="supportingImages && supportingImages.length"
          >
            <div v-for="d in supportingImages" :key="d.id">
              <img
                class="object-cover max-w-none heightwidth-84 h-auto rounded-lg overflow-hidden cursor-pointer"
                :src="baseUrlSrc(d.thumbnail_url)"
                alt=""
                @error="defaultImage"
                @mousedown="thumbnailSwitchHandler(d.thumbnail_url)"
                @mouseup="thumbnailSwitchHandler(defaultThumbImage)"
              />
            </div>
          </div>
      </div>
    </div>

    <!-- Begineer level -->
    <div class="grid xl:grid-cols-5 md:grid-cols-4 grid-cols-2 gap-4 mb-12">
      <div class="bg-gray-lighter rounded-lg pb-4 pl-4 pr-4 pt-5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="green"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-more-horizontal"
        >
          <circle cx="12" cy="12" r="1"></circle>
          <circle cx="19" cy="12" r="1"></circle>
          <circle cx="5" cy="12" r="1"></circle>
        </svg>

        <p class="text-gray-light text-xs mt-1">
          {{ details && details.difficulty_type }} level
        </p>
      </div>
      <div class="bg-gray-lighter rounded-lg p-4">
        <p class="font-bold">
          {{ details && details.language_name }}
        </p>
        <span class="text-gray-light text-xs">Language</span>
      </div>
      <div class="bg-gray-lighter rounded-lg p-4">
        <p class="font-bold">
          {{ minToHourMin(details && details.duration)[0] }}
          <span class="text-gray-light text-xs">hr</span>
          {{ minToHourMin(details && details.duration)[1] }}
          <span class="text-gray-light text-xs">mins</span>
        </p>
        <span class="text-gray-light text-xs">Avg Duration</span>
      </div>
      <div class="bg-gray-lighter rounded-lg p-4">
        <p class="font-bold">
          {{ total_student || "0" }}
        </p>
        <span class="text-gray-light text-xs">Students</span>
      </div>
      <div
        class="flex items-center"
        v-if="details && details.status == STATUS_STARTED"
      >
        <button
          type="button"
          class="inline-flex items-center h-12 px-2 text-sm text-white transition-colors duration-150 bg-green-light rounded-md focus:shadow-outline"
        >
          Tip the trainer
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import ZoomMtgEmbedded from "@zoomus/websdk/embedded";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SessionDetailsComponents",
  props: {
    details: {
      type: Object,
    },
    supportingImages: {
      type: Array,
    },
    total_student: {
      type: [Number, String],
    },
    zoom_meeting: {
      type: Object,
    },
  },
  data() {
    return {
      client: ZoomMtgEmbedded.createClient(),
      // This Sample App has been updated to use SDK App type credentials https://marketplace.zoom.us/docs/guides/build/sdk-app
      sdkKey: "JN61VXxPXfzVSUo8dSeFa2yTUBkCywpvmO2I",
      meetingNumber: "",
      passWord: "",
      signatureEndpoint: "https://cable.fitclass.com/",
      userEmail: this.getUser() && this.getUser().email,
      userName: this.getUser() && this.getUser().name,
      isMeetingStarted: false,
      // stripe: Stripe(
      //   "pk_live_51LavpOA4YItp06Z08A0BUBMtFG5t5yI6BVa4oW0tTJP5iCcbQSNv3ZjZMRp01AHsYvd5nYWNNqknYS7LmPcXFqH600w4UCvGNV",
      //   {
      //     stripeAccount: this.details && this.details.trainer_account_id,
      //   }
      // ),
      // The items the customer wants to buy
      items: {
        entityId: 5,
        entityType: 1,
        paymentMethodId: null, // value of existing card
        batchId: 50,
      },
      elements: {},
      defaultThumbImage: this.details && this.details.thumbnail_url,
      currentThumbnailImage: null
    };
  },
  computed: {
    ...mapGetters(["zoomSignature"]),
  },
  methods: {
    ...mapActions(["postZoomSignature"]),

    // zoomMeeting() {
    //   axios
    //     .post(`${this.signatureEndpoint}meeting`, {
    //       email: this.userEmail,
    //     })
    //     .then((response) => {
    //       // let URL =
    //       //   response.data.join_url.replaceAll(
    //       //     "https://us04web.zoom.us/j/",
    //       //     "http://localhost:9996/?"
    //       //   ) + `?role=1?name=${this.username}`;
    //       // window.location.replace(`${URL}`);
    //       this.url = new URL(response.data.join_url);
    //       // window.open(url);
    //       this.meetingNumber = this.url.pathname.substring(3);
    //       this.passWord = this.url.searchParams.get("pwd");
    //     })
    //     .catch((e) =>
    //       console.log(
    //         e &&
    //           e.response &&
    //           e.response.data &&
    //           e.response.data.error &&
    //           e.response.data.error.message
    //       )
    //     );
    // },

    getSignature() {
      const data = {
        meetingNumber: this.meetingNumber,
        role: 0, // Required, 0 to join the meeting / webinar, 1 to start the meeting.
      };
      axios
        .post(this.signatureEndpoint, data)
        .then((res) => {
          this.isMeetingStarted = true;
          this.startMeeting(res.data.signature);
        })
        .catch((e) => {
          console.log(e);
        });
      // this.postZoomSignature(data);
      // this.isMeetingStarted = true;
      // this.startMeeting(this.zoomSignature && this.zoomSignature.signature);
    },

    startMeeting(signature) {
      let meetingSDKElement = document.getElementById("meetingSDKElement");
      let meetingSDKChatElement = document.getElementById(
        "meetingSDKChatElement"
      );

      this.client.init({
        assetPath: "",
        customize: {
          activeApps: {
            popper: "",
          },
          chat: {
            notificationCls: {},
            popper: {
              anchorElement: meetingSDKChatElement,
              anchorPosition: "",
              anchorReference: "",
              disableDraggable: true,
              modifiers: {},
              placement: "top",
            },
          },
          inviteUrlFormat: "",
          meeting: {
            popper: "",
          },
          meetingInfo: [
            "topic",
            "host",
            // "mn",
            // "pwd",
            // "telPwd",
            // "invite",
            // "participant",
            "dc",
            "enctype",
          ],
          participants: {
            popper: "",
          },
          setting: {
            popper: "",
          },
          toolbar: {
            buttons: [
              // {
              //   text: "Custom Button",
              //   className: "CustomButton",
              //   onClick: () => {
              //     console.log("custom button");
              //   },
              // },
              {
                text: "Fullscreen",
                className: "CustomButton",
                onClick: () => {
                  this.toggleFullscreen();
                },
              },
            ],
          },
          video: {
            isResizable: false,
            popper: {
              disableDraggable: true,
            },
            viewSizes: {
              default: {
                // width: 1000,
                width: 840,
                // height: 600,
                height: 840 * 0.5625,
              },
              ribbon: {
                width: 300,
                height: 700,
              },
            },
          },
        },
        debug: true,
        language: "en-US",
        webEndpoint: "",
        zoomAppRoot: meetingSDKElement,
      });

      this.client.join({
        sdkKey: this.sdkKey,
        signature: signature,
        meetingNumber: this.meetingNumber,
        password: this.passWord,
        userName: this.userName,
        userEmail: this.userEmail,
        tk: "",
      });
    },

    toggleFullscreen() {
      var elem = document.getElementById("meetingSDKElement");
      if (
        window.fullScreen ||
        (window.innerWidth == screen.width &&
          window.innerHeight == screen.height)
      ) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE11 */
          document.msExitFullscreen();
        }
      } else {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Safari */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE11 */
          elem.msRequestFullscreen();
        }
      }
    },

    handleGiveReview() {
      this.$emit("give-review", true);
    },

    countdownHandler(date) {
      var startTime = new Date(this.convertUTCDateToLocalDate(date)).getTime();
      var countdownEle = document.querySelector("#countdown");
      countdownEle ? (countdownEle.innerText = "") : "";

      var x = setInterval(function () {
        var curTime = new Date().getTime();
        var duration = startTime - curTime;

        var days = Math.floor(duration / (1000 * 60 * 60 * 24));
        var hours = Math.floor(
          (duration % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        var mins = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));

        var html = "in ";
        if (days > 0) {
          html += days + " days ";
        } else {
          if (hours > 0) {
            html += hours + " hours ";
          } else {
            if (mins > 0) {
              html += mins + " mins ";
            }
          }
        }
        countdownEle ? (countdownEle.innerText = html) : "";

        if (duration < 0) {
          clearInterval(x);
          countdownEle ? (countdownEle.innerText = "Now") : "";
        }
      }, 1000);
    },
    thumbnailSwitchHandler (imagePath) {
      this.currentThumbnailImage = imagePath
    }

    // async handleSubmit(e) {
    //   e.preventDefault();
    //   setLoading(true);

    //   const { error } = await this.stripe.confirmPayment({
    //     elements: this.elements,
    //     confirmParams: {
    //       // Make sure to change this to your payment completion page
    //       return_url: "http://localhost:4242/public/checkout.html",
    //     },
    //   });

    //   // This point will only be reached if there is an immediate error when
    //   // confirming the payment. Otherwise, your customer will be redirected to
    //   // your `return_url`. For some payment methods like iDEAL, your customer will
    //   // be redirected to an intermediate site first to authorize the payment, then
    //   // redirected to the `return_url`.
    //   if (error.type === "card_error" || error.type === "validation_error") {
    //     showMessage(error.message);
    //   } else {
    //     showMessage("An unexpected error occurred.");
    //   }

    //   setLoading(false);
    // },

    // async handleSubmit(e) {
    //   e.preventDefault();
    //   // disable the submit button while processing payment

    //   await this.stripe
    //     .confirmPayment({
    //       elements: this.elements,
    //       redirect: "if_required",
    //     })
    //     .then(function (result) {
    //       if (result.error) {
    //         // Show error message using (result.error.message);
    //         // enable payment button
    //       } else {
    //         switch (result.paymentIntent.status) {
    //           case "succeeded":
    //             // Create http request to save result.paymentIntent.id in to database
    //             break;
    //           case "processing":
    //             // show Your Payment is Processing success message to user
    //             break;
    //           case "requires_payment_method":
    //             // Your payment was not successful, please try again.
    //             break;
    //           default:
    //             // Something went wrong error message
    //             break;
    //         }
    //       }
    //     });
    // },
  },
  created() {
    this.meetingNumber = this.zoom_meeting && this.zoom_meeting.meeting_id;
    this.passWord = this.zoom_meeting && this.zoom_meeting.meeting_password;
  },
  mounted() {
    this.countdownHandler(this.details && this.details.upcoming_live);
    this.currentThumbnailImage = this.defaultThumbImage
  },
};
</script>

<style scoped>
.heightwidth-84 {
  height: 84px;
  width: 84px;
}
</style>

<style>
#meetingSDKElement
  .zmwebsdk-makeStyles-videoCustomize-1
  .zmwebsdk-makeStyles-singleView-7 {
  box-shadow: none !important;
}
#meetingSDKElement
  .zmwebsdk-makeStyles-videoCustomize-1
  .zmwebsdk-MuiPaper-rounded {
  border-top-right-radius: 0% !important;
  border-bottom-right-radius: 0% !important;
}
.image-container{
  height: 500px;
  overflow: hidden;
  background-size: cover;
  border-radius: 8px;
}
@media (max-width: 767px){
  .image-container{
    height: 300px;
  }
}
</style>